import marked from 'marked';
import React from 'react';
import { BoxComponentProps } from '../../boxTypes';
import './Wirecutter.style.scss';
import './responsive.scss';

export const templateName = 'wirecutter';
export const templateID = `tk-showcase-${templateName}`;
export const colors = [
  {
    colorLabel: 'Primary Color',
    colorValue: '#d6363c',
  },
  { colorLabel: 'Ribbon Color', colorValue: '#1b4abe' },
  {
    colorLabel: 'CTA Color',
    colorValue: '#fff',
  },
  {
    colorLabel: 'CTA-BG Color',
    colorValue: '#d6363c',
  },
];

const Simple: React.FC<BoxComponentProps> = ({
  formData,
  config,
  isPreview,
}) => {
  const { fieldData } = formData;
  const { linkRel, externalLink } = config;

  if (!formData.fieldData.length) return null;

  return (
    <div
      id="tableskit"
      className={`tableskit tk-${templateName} ${templateID}`}
    >
      <div className="tk-card-grid">
        {fieldData.map(({ fields, id }) => {
          const {
            buyButtonText,
            imageURL,
            productBody,
            productSubtitle,
            productTitle,
            productURL,
            ribbonText,
            cTASubtitle,
          } = fields;
          return (
            <div className="tk-card-wrapper" key={id}>
              {ribbonText && <div className="tk-ribbon">{ribbonText}</div>}
              <div className="tk-image-wrapper">
                <a
                  href={productURL}
                  target={externalLink || isPreview ? '_blank' : undefined}
                  rel={`noreferrer ${linkRel}`}
                >
                  <img src={imageURL} alt={productTitle} />
                </a>
              </div>
              <div className="tk-body-wrapper">
                <a
                  href={productURL}
                  target={externalLink || isPreview ? '_blank' : undefined}
                  rel={`noreferrer ${linkRel}`}
                >
                  <div className="tk-card-title">{productTitle}</div>
                </a>
                <p className="tk-card-subtitle">{productSubtitle}</p>
                <div
                  className="tk-body"
                  dangerouslySetInnerHTML={{
                    __html: marked(productBody || ''),
                  }}
                />
                <div className="tk-cta-wrapper">
                  <a
                    href={productURL}
                    target={externalLink || isPreview ? '_blank' : undefined}
                    rel={`noreferrer ${linkRel}`}
                    className="tk-cta"
                  >
                    {buyButtonText}
                  </a>
                  {cTASubtitle && (
                    <span className="tk-cta-subtitle">{cTASubtitle}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Simple;
